import Search from './Search';
import Controler from '../base/Controler';

class SearchControler extends Controler {
  constructor() {
    super();

    this.mountPopups();
  }

  private mountPopups(): void {
    (this.selectElements('.js-search') as NodeListOf<HTMLFormElement>).forEach(
      searchForm => {
        const search = new Search(searchForm);
      }
    );
  }
}

export default SearchControler;
